import {Card} from 'platform/components';
import {Box, VStack} from 'platform/foundation';

import {useCallback} from 'react';

import {mergeAll} from 'ramda';

import i18n from '@dms/i18n';
import {rentalOrderRoutes, testIds} from '@dms/routes';
import {CommunicationActivityLogDatagrid, DmsDataGrid, Main, PageTab} from '@dms/shared';

import {composePath, useRequiredParams} from 'shared/web';

import type {QueryFilterObject} from 'features/eag-grid';

export function ActivityLogs() {
  const {id} = useRequiredParams();

  const activityLogQueryModifier = useCallback(
    (filter: QueryFilterObject) => mergeAll([filter, {rentalOrderId: id}]),
    [id]
  );

  const emailActivityLogQueryModifier = useCallback(
    (filter: QueryFilterObject) => ({...filter, recordId: id, customerId: undefined}),
    [id]
  );

  const tabs: PageTab[] = [
    {
      href: composePath(rentalOrderRoutes.activityLogs, {params: {id}}),
      content: (
        <Card title={i18n.t('general.labels.activityLogs')} key="activity-logs-datagrid">
          <Box height={130}>
            <DmsDataGrid
              gridCode="rental-order-audit-log"
              queryModifier={activityLogQueryModifier}
              data-testid="activity-logs-datagrid"
            />
          </Box>
        </Card>
      ),
      id: 'rental-order-action-logs',
      title: i18n.t('general.labels.activityLogs'),
      'data-testid': testIds.rentalOrder.activityLogs('navigation-rental-order-action-logs'),
    },
    {
      href: composePath(rentalOrderRoutes.emailActivityLogs, {
        params: {id},
      }),
      content: (
        <Card title={i18n.t('general.labels.emailActivityLogs')} key="email-activity-logs-datagrid">
          <Box height={130}>
            <CommunicationActivityLogDatagrid
              queryModifier={emailActivityLogQueryModifier}
              presetInstanceId="rental-order-email-activity-logs"
              data-testid="rental-order-email-activity-logs-datagrid"
            />
          </Box>
        </Card>
      ),
      id: 'rental-order-email-activity-logs',
      title: i18n.t('general.labels.emailActivityLogs'),
      'data-testid': testIds.rentalOrder.emailActivityLogs(
        'navigation-rental-order-email-activity-logs'
      ),
    },
  ];

  return (
    <VStack width="100%">
      <Main tabs={tabs} />
    </VStack>
  );
}
